import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "app-tooltip",
    templateUrl: "./tooltip.component.html",
    styleUrls: ["./tooltip.component.scss"],
    standalone: false
})
export class TooltipComponent implements OnInit {
  @Input() title: string = "";
  @Input() icon: string = "";
  @Input() idTooltip: string = "";
  @Input() image: string = "";
  @Input() type = "left";

  public srcIcon : string;
  constructor() {}

  ngOnInit() {
    this.srcIcon = `../../../assets/icons/${this.icon}.svg`
  }
}
